var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { FormattedMessage } from "@irati/utils/lang";
import { RouterLink } from "@irati/ui/src/Link";
import { Para } from "@irati/ui/src/Labels";
import Button from "@irati/ui/src/Button";
import authentication from "@irati/auth";
import { GhostActionsArea } from "./styled";
var GhostAdmin = /** @class */ (function (_super) {
    __extends(GhostAdmin, _super);
    function GhostAdmin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GhostAdmin.prototype.render = function () {
        var contextApps = this.context.apps;
        var isGhostUser = authentication.isUserGhost();
        if (!isGhostUser)
            return null;
        return (React.createElement(GhostActionsArea, null,
            React.createElement(Para, { large: true },
                React.createElement(FormattedMessage, { id: "setup_tenant.ghostActions.title" })),
            React.createElement(RouterLink, { primary: true, to: "/", app: contextApps.ADMIN },
                React.createElement(Button, { primary: true },
                    React.createElement(FormattedMessage, { id: "platform.header.adminButton.admin" })))));
    };
    GhostAdmin.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return GhostAdmin;
}(Component));
export default GhostAdmin;
